export enum TipoPreco {
    ATACADO = 'ATACADO',
    VAREJO = 'VAREJO',
    FABRICA = 'FABRICA'
  }
  